export default __webpack_public_path__ + "static/media/avatarPic.c2af3188.svg";